import { Logo, MinisiteConfiguration } from '@3ddv/ngx-sites-builder-lib';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, finalize, Subscription } from 'rxjs';
import { ContentDistributionVenuesApiService } from 'src/app/content-distribution/private/entities/venues/services/contentdistributionvenues.service';
import { ClientModel } from 'src/app/shared/models/client.model';
import { VenueModel } from 'src/app/shared/models/venue.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { apiSiteGetResponse, SiteModel } from 'src/app/sites-builder/models/site.model';
import { SbApiService } from 'src/app/sites-builder/services/sb-api.service';
import { VenuesService } from 'src/app/venues/private/services/venues.service';
import { environment } from 'src/environments/environment';
import { Logofavicon } from '../../sb-editor-sidebar/header/logofavicon/models/logofavicon.model';
import { CopySiteModel } from './models/CopySite.model';

@Component({
  selector: 'app-site-copy',
  templateUrl: './site-copy.component.html',
  styleUrls: ['./site-copy.component.scss', '../save-minisite/save-minisite.component.scss'],
})
export class SiteCopyComponent implements OnInit, OnDestroy {
  public sitedatabase: SiteModel;
  public siteconfiguration: MinisiteConfiguration;
  public venue: VenueModel;
  public sitealreadyExists: apiSiteGetResponse = null;
  public checkdeleteconfirm: boolean = false;
  public checkedSite: boolean = false;
  public deletingSite: boolean = false;
  public closeReason: 'success' | 'cancel';
  public loading: boolean = true;
  public subscriptions: Array<Subscription> = [];
  editModes: { venueId: boolean };
  public newMaster: CopySiteModel = {
    client: '',
    enabled: false,
    map_id: '',
    minimap_id: '',
    venue_id: '',
  };
  public dropdownSettings = {};
  public clientList: Array<ClientModel>;
  public clientSelected: Array<{ key: string; name: string }> = [];
  public venueList: Array<VenueModel>;
  public venueSelected: { key: string; name: string };

  public logoPreview: SafeUrl;
  public faviconNewPreview: SafeUrl;
  public logoNew: any;
  public faviconNew: any;
  public logoNewPreview: SafeUrl;
  public faviconPreview: SafeUrl;
  private venueIdSubject = new BehaviorSubject<string>('');
  private logofaviconTool: Logofavicon = { logo: null, favicon: null };
  private logofaviconBackups: {
    logo: any;
    favicon: any;
  } = {
      logo: null,
      favicon: null,
    };
  isSiteForTest: boolean = false;
  public libVersion: string;

  constructor(
    private sbapiService: SbApiService,
    private bsModalRef: BsModalRef,
    private venuesService: VenuesService,
    private authService: AuthService,
    private toastrService: ToastrService,
    private cdClientService: ContentDistributionVenuesApiService
  ) {
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'key',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
    };
    this.editModes = { venueId: false };
  }

  public changeEditMode(feature: string) {
    if (!feature) return;
    this.editModes[feature] = !this.editModes[feature];
  }

  public cancelEditMode(feature: string): void {
    if (!feature) return;
    this.changeEditMode(feature);
  }

  public updateVenue(feature: string) {
    if (!feature) return;
    this.venueIdSubject.next(this.newMaster.venue_id);
    this.changeEditMode(feature);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  ngOnInit(): void {
    console.log(this.venue)
    const master$ = this.sbapiService.getMasterFile(this.sitedatabase.path_master).subscribe({
      next: response => {
        this.siteconfiguration = Object.assign({}, response);

        this.newMaster.client = JSON.parse(JSON.stringify(this.siteconfiguration.mapConfig.client));
        this.newMaster.enabled = JSON.parse(JSON.stringify(this.siteconfiguration.mapConfig.enabled));
        this.newMaster.map_id = JSON.parse(JSON.stringify(this.siteconfiguration.mapConfig.map_id));
        this.newMaster.venue_id = JSON.parse(JSON.stringify(this.siteconfiguration.mapConfig.venue_id));
        if (this.siteconfiguration.toolsConfig.minimap && this.siteconfiguration.toolsConfig.minimap.enabled) {
          this.newMaster.minimap_id = JSON.parse(JSON.stringify(this.siteconfiguration.toolsConfig.minimap.map_id));
        }
        this.venueIdSubject.next(this.newMaster.venue_id);
        this.showLogo();
        this.showFavicon();
        this.loading = false;
      },
      error: error => console.error(error),
    });
    this.isSiteForTest = this.sitedatabase.isTest;
    this.subscriptions.push(master$);

    const client$ = this.authService.getClientList().subscribe(clients => {
      this.clientList = clients.data;
      if (this.sitedatabase) {
        const s = this.clientList.filter(i => i.key === this.sitedatabase.client_key);
        if (s.length) {
          this.clientSelected = [s[0]];
        }
      }
    });
    this.subscriptions.push(client$);
    this.venueSelected = {key: this.venue.key, name: this.venue.name}
  }

  private showLogo() {
    this.logofaviconTool.logo = this.siteconfiguration.toolsConfig.logo;
    if (this.logofaviconTool.logo.file) {
      const reader = new FileReader();
      reader.readAsDataURL(this.logofaviconTool.logo.file);
      reader.onload = _event => {
        this.logoPreview = reader.result;
      };
    } else if (this.logofaviconTool.logo.path && this.siteconfiguration.mapConfig.client) {
      const url =
        environment.sitesBuilder.staticrsc_cdn +
        this.siteconfiguration.mapConfig.client +
        this.logofaviconTool.logo.path;
      this.logoPreview = url;

      const logo$ = this.sbapiService.getImageIntoBlobFile(url).subscribe(res => {
        this.logofaviconTool.logo.file = new File([res], this.logofaviconTool.logo.path.split('/').pop());
      });
      this.subscriptions.push(logo$);
    } else if (this.isLogoType(this.logofaviconTool.logo) && this.logofaviconTool.logo.default) {
      this.logoPreview = '/assets/img/3ddv/3ddv.png';
    }
  }

  private showFavicon() {
    this.logofaviconTool.favicon = this.siteconfiguration.toolsConfig.favicon;
    if (!this.logofaviconTool.favicon.file && !this.logofaviconTool.favicon.path) {
      this.faviconPreview = '/assets/img/3ddv/favicon-3ddv.png';
    }
    if (this.logofaviconTool.favicon.file) {
      const reader = new FileReader();
      reader.readAsDataURL(this.logofaviconTool.favicon.file);
      reader.onload = _event => {
        this.faviconPreview = reader.result;
      };
    } else if (this.logofaviconTool.favicon.path && this.siteconfiguration.mapConfig.client) {
      const url =
        environment.sitesBuilder.staticrsc_cdn +
        this.siteconfiguration.mapConfig.client +
        this.logofaviconTool.logo.path;
      this.faviconPreview = url;
      const favicon$ = this.sbapiService.getImageIntoBlobFile(url).subscribe(res => {
        this.logofaviconTool.favicon.file = new File([res], this.logofaviconTool.favicon.path.split('/').pop());
      });
      this.subscriptions.push(favicon$);
    }
  }

  public isLogoType(x: unknown): x is Logo {
    if (!x) return false;
    if (typeof (x as any).default === 'boolean') return true;
    return false;
  }

  public deletesite(id: number) {
    this.deletingSite = true;
    this.loading = true;
    const delete$ = this.sbapiService.deleteSite(id).subscribe(res => {
      this.deletingSite = false;
      this.checkdeleteconfirm = false;
      this.sitealreadyExists = null;
      this.loading = false;
    });
    this.subscriptions.push(delete$);
  }

  public onDismiss(reason: 'cancel') {
    this.closeReason = reason;
    this.bsModalRef.hide();
  }

  public onConfirm() {
    this.loading = true;
    // Check if site already exists
    this.sitealreadyExists = null;
    const site$ = this.sbapiService.getSiteByTitle(this.newMaster.client).subscribe({
      next: (res) => {
        this.checkdeleteconfirm = false;
        this.sitealreadyExists = res
        this.loading = false;
      },
      error: () => {
        this.checkdeleteconfirm = false;
        this.sitealreadyExists = null;
        this.createFormData();
      },
    })
    this.subscriptions.push(site$);
  }

  private createFormData() {
    this.loading = true;
    // Data to transform into json file to upload
    const formData: FormData = new FormData();

    this.siteconfiguration.mapConfig.client = this.newMaster.client;
    this.siteconfiguration.mapConfig.enabled = Boolean(this.newMaster.enabled);
    this.siteconfiguration.mapConfig.venue_id = this.newMaster.venue_id;
    this.siteconfiguration.mapConfig.map_id = this.newMaster.map_id;
    this.siteconfiguration.toolsConfig = Object.assign({}, this.siteconfiguration.toolsConfig);

    // Tools with images to append: logo, multivenue
    //1. Append logo
    if (this.logofaviconTool.logo.file) {
      let ext_split = this.logofaviconTool.logo.file.name.split('.');
      let ext = ext_split[ext_split.length - 1];
      formData.append('logo_file', this.logofaviconTool.logo.file, 'logo.' + ext);
      this.logofaviconTool.logo.file = null;
    }
    //1.2 Append favicom
    if (this.logofaviconTool.favicon.file) {
      let ext_split = this.logofaviconTool.favicon.file.name.split('.');
      let ext = ext_split[ext_split.length - 1];
      formData.append('favicon_file', this.logofaviconTool.favicon.file, 'favicon.' + ext);
      this.logofaviconTool.favicon.file = null;
    }

    if (this.siteconfiguration.toolsConfig.credential.enabled) {
      this.siteconfiguration.toolsConfig.credential.enabled = false;
    }
    // Transform json to string
    const body = JSON.stringify(this.siteconfiguration);
    const blob = new Blob([body], { type: 'application/json' });
    // Transform string to file
    const file = new File([blob], 'master.json');
    // Create form
    formData.append('master_file', file);
    // Send form as body
    // BD required data
    formData.append('client_key', this.clientSelected[0].key);
    formData.append('venue_key', this.venueSelected.key);
    formData.append('workflow_id', this.siteconfiguration.mapConfig.workflow_id.toString());
    formData.append('title', this.newMaster.client);
    formData.append('url', environment.sitesBuilder.app_url + this.newMaster.client);
    formData.append('venue_code', this.newMaster.venue_id);
    let is_active = false;
    if (this.newMaster.enabled) {
      is_active = true;
    }
    formData.append('map_id', this.newMaster.map_id);
    formData.append('is_active', is_active.toString());
    formData.append('isTest', this.isSiteForTest.toString());
    formData.append('libversion', this.libVersion);

    const post$ = this.sbapiService.createSite(formData).subscribe(res => {
      this.loading = false;
      console.log(res);
      if (res.site) {
        this.closeReason = 'success';
        this.bsModalRef.hide();
      }
    });
    this.subscriptions.push(post$);
  }

  public checkIfExists() {
    this.loading = true;
    // Check if site already exists
    this.sitealreadyExists = null;
    this.checkdeleteconfirm = false;
    this.checkedSite = false;
    const site$ = this.sbapiService.getSiteByTitle(this.newMaster.client).pipe(
      finalize(() => this.loading = false)
    ).subscribe({
      next: (res) => this.sitealreadyExists = res,
      error: () => this.checkedSite = true
    })
    this.subscriptions.push(site$);
  }

  private validateFile($event) {
    let error = null;
    if (
      ($event.target.files[0].type == '' && $event.target.files[0].size == 0) ||
      ($event.target.files[0].type != 'image/jpeg' && $event.target.files[0].type != 'image/png')
    ) {
      error = 'Formato del fichero inválido';
    }
    return error;
  }

  public updateLogo($event) {
    if (!$event.target.files.length) {
      if (this.logofaviconBackups.logo) {
        this.siteconfiguration.toolsConfig.logo.file = JSON.parse(JSON.stringify(this.logofaviconBackups.logo));
      }
      this.logoNewPreview = null;
      return;
    }
    const error = this.validateFile($event);
    if (error) {
      this.toastrService.error('', error);
      return;
    }
    this.logofaviconBackups.logo = JSON.parse(JSON.stringify(this.siteconfiguration.toolsConfig.logo.file));
    this.siteconfiguration.toolsConfig.logo.file = $event.target.files[0];
    this.loadNewPreview($event.target.files[0], 'logo');
  }

  public updateFavicon($event) {
    if (!$event.target.files.length) {
      if (this.logofaviconBackups.favicon) {
        this.siteconfiguration.toolsConfig.favicon.file = JSON.parse(JSON.stringify(this.logofaviconBackups.favicon));
      }
      this.faviconNewPreview = null;
      return;
    }
    const error = this.validateFile($event);
    if (error) {
      this.toastrService.error('', error);
      return;
    }
    this.logofaviconBackups.favicon = JSON.parse(JSON.stringify(this.siteconfiguration.toolsConfig.favicon.file));
    this.siteconfiguration.toolsConfig.favicon.file = $event.target.files[0];
    this.loadNewPreview($event.target.files[0], 'favicon');
  }

  private loadNewPreview(file, toolname) {
    let ext = file.name.split('.').pop();
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = _event => {
      if (toolname === 'logo') {
        this.logoNewPreview = reader.result;
        this.siteconfiguration.toolsConfig.logo.path = '/latest/img/logo.' + ext;
      } else if (toolname === 'favicon') {
        this.faviconNewPreview = reader.result;
        this.siteconfiguration.toolsConfig.favicon.path = '/latest/img/favicon.' + ext;
      }
    };
  }
}
